import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Applayout } from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";

function App() {
  useEffect(() => {
    const savedLang = localStorage.getItem("lang");

    try {
      const parsedLang = savedLang ? JSON.parse(savedLang) : null;
      if (!parsedLang || (parsedLang !== "en" && parsedLang !== "ar")) {
        localStorage.setItem("lang", JSON.stringify("en"));
      }
    } catch (error) {
      localStorage.setItem("lang", JSON.stringify("en"));
    }
  }, []);

  return (
    <BrowserRouter>
      <ToastContainer autoClose={3000} hideProgressBar={false} />
      <Applayout />
    </BrowserRouter>
  );
}

export default App;
